module.exports = __webpack_public_path__ + "media/images/sp/articles/recommend_temp_03-dcca907b2d11b61aaac184fdaceee323.webp";